import gql from 'graphql-tag';

export const GET_LOCATIONS = gql`
  query GetLocationsForNotificationManagement {
    locations {
      locationId
      locationName
      category
      locationParentId
    }
  }
`;
